import { render, staticRenderFns } from "./SchoolLeaveDetailPageTable.vue?vue&type=template&id=37d5ef4b&scoped=true&"
import script from "./SchoolLeaveDetailPageTable.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveDetailPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5ef4b",
  null
  
)

export default component.exports